<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="pa-4">
      <v-toolbar dense flat class="custom-toolbar ma-2">
        <v-toolbar-title>Payment History</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <div class="responsive-table-container">
      <v-data-table
        :search="search"
        :headers="headers"
        :items="payment_history"
        class="elevation-1"
        dense
        style="padding: 10px"
        hide-default-header
      >
        <template v-slot:header="{ props }">
          <thead>
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.value"
                class="custom-header"
              >
                {{ header.text }}
              </th>
            </tr>
          </thead>
        </template>
      </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    learner: {
      type: [String, Number], // Adjust type based on your actual value
      required: true,
    },
  },
  data() {
    return {
      color: "",
      snackbar: false,
      snackbar_msg: "",
      headers: [
        {
          text: "Sr. No.",
          align: "left",
          sortable: false,
          value: "srno",
        },
        {
          text: "Learner",
          align: "left",
          sortable: false,
          value: "learner",
        },
        {
          text: "Amount",
          align: "left",
          sortable: false,
          value: "amount",
        },
        {
          text: "Paid For",
          align: "left",
          sortable: false,
          value: "purpose",
        },
        {
          text: "Order Id",
          align: "left",
          sortable: true,
          value: "order_id",
        },
        {
          text: "Transaction Id",
          align: "left",
          sortable: true,
          value: "trxn_id",
        },
        {
          text: "Transaction Date",
          value: "transaction_date",
          sortable: false,
        },
        {
          text: "Payment Status",
          value: "paymenttransactionstatus",
          sortable: false,
        },
        { text: "Payment Mode", value: "mode", sortable: false },
      ],
      payment_history: [],
    };
  },
  watch: {
    learner(newVal, oldVal) {
      if (newVal) {
        this.getChildPaymentHistoryDetails();
      }
    },
  },
  methods: {
    getChildPaymentHistoryDetails() {
      const data = {
        learner: this.learner,
      };
      axios
        .post("/parent/getChildPaymentHistoryDetails", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            // this.showSnackbar("success", "yaayyyyyy")
            this.payment_history = res.data.payment_history;
          } else if (res.data.flag == "NO") {
            this.showSnackbar("error", res.data.snackbar);
          } else {
            this.showSnackbar("error", "Something went wrong...");
          }
        })
        .catch((error) => {
          this.onerror(error);
        })
        .finally(() => {});
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.getChildPaymentHistoryDetails();
  },
};
</script>

<style scoped>
.custom-header {
  background: linear-gradient(to right, #FFE0B2, #FFCCBC);
  color: black !important; /* Optional: makes text readable */
  font-weight: bold;
  white-space: nowrap;
  text-align: center;
}
.responsive-table-container {
  width: 100%;
  overflow-x: auto;
}
.custom-toolbar {
  background: linear-gradient(to right, #a8edea, #e4d0ff);
  background: linear-gradient(to right, #a8edea, #e4d0ff);
}
</style>